export const SIMPLE_DATE_FORMAT = 'd/M/yyyy'

export const SIMPLE_DATETIME_FORMAT = 'dd/MM/yyyy HH:mm'
